/* eslint-disable no-restricted-globals */
export function localStorageGet(key: string): string {
    try {
        return localStorage.getItem(key);
    } catch {
        return undefined;
    }
}

export function localStorageSet(key: string, value: string): void {
    try {
        localStorage.setItem(key, value);
    } catch {
        // do nothing
    }
}

export function localStorageRemove(key: string): void {
    try {
        localStorage.removeItem(key);
    } catch {
        // do nothing
    }
}

export function sessionStorageGet(key: string): string {
    try {
        return sessionStorage.getItem(key);
    } catch {
        return undefined;
    }
}

export function sessionStorageSet(key: string, value: string): void {
    try {
        sessionStorage.setItem(key, value);
    } catch {
        // do nothing
    }
}

export function sessionStorageRemove(key: string): void {
    try {
        sessionStorage.removeItem(key);
    } catch {
        // do nothing
    }
}
